export const EVENT_ADD_OFFER_TO_CART = 'tracking/ADD_OFFER_TO_CART';
export const EVENT_PAGE_LOAD = 'tracking/PAGE_LOAD';
export const EVENT_PAGE_VIEW = 'tracking/PAGE_VIEW';
export const EVENT_SELECT_HOTEL_ITEM = 'tracking/EVENT_SELECT_HOTEL_ITEM';
export const EVENT_FILTER_SET = 'tracking/FILTER_SET';
export const EVENT_FILTER_REMOVE = 'tracking/FILTER_REMOVE';
export const EVENT_BEST_OFFER_BOXES_LOADED =
  'tracking/EVENT_BEST_OFFER_BOXES_LOADED';
export const EVENT_SELECT_PROMOTION = 'tracking/EVENT_SELECT_PROMOTION';
export const EVENT_BD4_RECOMMENDED_LOADED =
  'tracking/EVENT_BD4_RECOMMENDED_LOADED';
export const EVENT_BD4_RECOMMENDED_CLICKED =
  'tracking/EVENT_BD4_RECOMMENDED_CLICKED';
